import { LogoARASAAC, LogoCNSE } from '../assets/images';
import SignProvider from '../models/SignProvider';

const provider_icon_map: Record<string, string> = {
    'ARASAAC': LogoARASAAC,
    'CNSE': LogoCNSE,
}

export function get_provider_icon(provider?: SignProvider) {
    if (provider === undefined)
        return null;
    
    return provider.name in provider_icon_map ?
        <a className={'provider-icon prov-'+provider.name} href={provider?.url} target="_blank" rel="noreferrer">
            <img src={provider_icon_map[provider.name]} alt={provider.name + " icon"} />
        </a>

    : null;
}

export function get_provider_copyright(provider?: SignProvider) {
    if (provider === undefined)
        return null;

    if (provider.name === 'ARASAAC')
        return <div className='copyright-text'>
            Los vídeos en LSE utilizados son propiedad del Gobierno de Aragón y han sido creados por ASZA para ARASAAC (<a href={provider.url} target='_blank'  rel="noreferrer">{provider.url}</a>), que los distribuye bajo Licencia Creative Commons BY-NC-SA.
        </div>

    return null;
}

export function get_copyright_icon(provider?: SignProvider) {
    if (provider === undefined)
        return null;

    if (provider.copyright_type === "CC (BY-NC-SA)")
        return <a className={'copyright-icon prov-'+provider.name} href={get_copyright_url(provider)} target="_blank" rel="noreferrer">
            <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/svg/by-nc-sa.svg' alt={"Copyright icon: " + provider.copyright_type} />
        </a>

    return null;
}

export function get_copyright_url(provider?: SignProvider) {
    if (provider === undefined)
        return '';

    if (provider.copyright_type === "CC (BY-NC-SA)")
        return "https://creativecommons.org/licenses/by-nc-sa/4.0/"
}
